module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/ko/1/4-48a5e17ea4b3edd32529dac35a832f8f.jpg";